import { IAddress } from './Adress'

export interface IUser {
  id: string
  firstname: string
  surname: string
  gender: string
  email: string
  email2: string
  mobile: string
  mobile2: string
  address: IAddress
  dateOfBirth: Date
  isActive: boolean
  isMember: boolean
  lastLoggedIn: Date
  lastUpdated: Date
  magazineCode: string
  memberNumber: number
  memberCashbackAccount: string
  acceptElectronicCommunication: boolean
  acceptElectronicCommunicationChangedDate: boolean
  bblId: string
  bblIdEmail: string
  bblIdMobile: string
  iamMailVerified: boolean
  iamMobileVerified: boolean
  nameId: number
  settings: { data: IUserSettings; loading: boolean; error: boolean }
  roles: IUserRoles[]
  notifications: INotification[]
  updateError?: boolean
}

export interface IUserSettings {
  invoiceApprovalCanApproveFromListView: boolean
  invoiceApprovalShowRejected: boolean
  loading: boolean
}

export interface IUserRoles {
  role: UserRoleEnum
  reference: IRoleReference[]
}

export interface IRoleReference {
  value: string
  type: ReferenceType
}

export enum ReferenceType {
  ClientId = 'ClientId',
  UnitId = 'UnitId',
}

export enum ReferenceTypeNumerable {
  ClientId = 1,
  UnitId = 2,
}

export interface INotification {
  id: number
  description: string
  email: boolean
  sms: boolean
  portal: boolean
  standard: boolean
  standardForBoardMember: boolean
  active: boolean
  processing: boolean
  showForEditInBoardPortal: boolean
  showForEditInMyPage: boolean
}

export interface IHandleNotification {
  id: number
  active: boolean
}

export interface IHandleSetting {
  type: string
  active: boolean
}

export interface IActiveNotification {
  typeId: number
  typeDescription: string
  email: boolean
  sms: boolean
  isAvailableInPortal: boolean
  active: boolean
}

export enum UserRoleEnum {
  owner = 'Eier',
  tenant = 'Leietaker',
  cohabitant = 'Beboer',
  member = 'Medlem',
  portal = 'StyreportalBruker',
  invoiceApprover = 'FakturaGodkjenner',
  invoiceAttester = 'FakturaAttesterer',
  boardleader = 'StyreLeder',
  boardmember = 'StyreMedlem',
  boardnextleader = 'StyreNestleder',
  alternateboardmember = 'StyreVaraMedlem',
  secretary = 'StyreSekretær',
  cashier = 'StyreKasserer',
  committee = 'StyreValgKomite',
  accountant = 'Revisor',
  powerofattorney = 'Fullmaktshaver',
  caretaker = 'Vaktmester',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  auditor = 'Revisor',
  digitalkeys = 'DigitaleNokler',
  advisor = 'Raadgiver',
  advisorFullAccess = 'RaadgiverMedFullTilgang',
  preemption = 'ForkjopsrettBruker',
  support = 'TekniskSupport',
  ceo = 'StyreTilknyttetDagligLeder',
}

export enum BoardMemberFunctions {
  BoardLeader = 'Styreleder',
  BoardDeputyLeader = 'Nestleder',
  BoardMember = 'Styremedlem',
  BoardDeputyMember = 'Varamedlem',
  CEO = 'Daglig leder',
}

export enum UserSettingsEnum {
  approveFromList = 'GodkjenningFromListview',
}

export enum NotificationTypeIdEnum {
  newInvoiceEmail = 1,
  newInvoiceSMS = 2,
  expiringInvoiceEmail = 3,
  expiringInvoiceSMS = 4,
  documentEmail = 51,
  publicationEmail = 52,
  budgetEmail = 60,
  annualReportEmail = 70,
  annualMeetingNoticeEmail = 80,
  annualMeetingProtocolEmail = 90,
  documentForSigningEmail = 100,
  newEmailEmail = 101,
  expiringTaskEmail = 110,
  expiringTenantEmail = 120,
  bookingEmail = 140,
}
